/* eslint-disable */

import React from "react";

import RaindropButton from "../../../ui-components/raindrop-button/raindrop-button.tsx";

import RaindropTitle from "../../../ui-components/raindrop-title/raindrop-title.tsx";
import { Size } from "../../../logic/enums.ts";

const CirrusEntry = ({ isDemo, setUserCurrent }) => {
  const colorBackground =
    "bg-color-dark-background-primary bg-color-background-primary";
  const border = "border border-color-dark-border-primary";

  return (
    <div className="flex flex-col h-full w-full gap-20">
      <div className="flex flex-col items-center">
        <RaindropTitle isTertiary={true} />
        <h1 className="w-full text-center max-w-xs text-2xl font-bold text-color-raindrop-primary">
          for charities
        </h1>
      </div>

      <div className="flex flex-col gap-4 items-center justify-center">
        <RaindropButton
          title={"Sign up"}
          style={ButtonStyle.Primary}
          to={"/cirrus/sign-up"}
          size={Size.Large}
        />
        <RaindropButton
          title={"Log in"}
          to={"/cirrus/login"}
          style={ButtonStyle.Secondary}
        />
      </div>
    </div>
  );
};

export default CirrusEntry;
